// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"91564080","453":"bb563f25","732":"50f670e8"}[chunkId] + ".chunk.js";
};